import { HttpClient } from '@angular/common/http';
import { ENV_CONSTANTS } from '@env-properties/environment';
import { ENV_CONFIG } from '@env-properties/environment-config';
import { APP_SETTINGS } from '@mainrepo/app/core/constants/AppSettings';
import { UPLOAD_CONS } from '@mainrepo/app/core/constants/UploadConstants';
import { GlobalClassInstance } from '../constants/GlobalClass';
import { LoginExceptions } from '../exception/LoginExceptions';
import { UserLoginImplementation } from './UserLoginImplementation';

export class AppSettingImplementation {
    public universalService: any;
    public exception: any;
    public router: any;
    public globalService:any;
    public localStorageSvc: any;
    public http: HttpClient;
    public loginImpl:any;
    constructor(globalService) {
      this.exception = new LoginExceptions(globalService);
      this.universalService=globalService.getUniversalServiceRef();
      this.globalService = globalService;
      this.localStorageSvc = globalService.getLocalStorageSvcRef();
      this.http = this.globalService.getHttpClientRef();
      this.loginImpl = UserLoginImplementation.getInstance(globalService);
      this.router = globalService.getRouterRef();
    }

    setAppSetting(dcGroupCode){
        const self = this;
        let serviceUrl = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["pbsURL"] + ENV_CONFIG.commonUrls["getAppSetting"]; 
        if(this.universalService.inAppWebViewOpened || window.location.href.includes("/webview")){
            let type = this.universalService.isIOSDevice ? "ios" : "android"
            let os = "os="+type;
            serviceUrl = serviceUrl.replace("os=web",os);
        }
        return new Promise((resolve,reject)=>{
            self.http.get(serviceUrl).subscribe(
                suc => {
                    if(!dcGroupCode){
                        dcGroupCode = suc["defaultDcGroupCode"];
                    }
                    self.populateTheMultiDCURLsInENV(suc);
                    resolve(suc);
                },
                error => {
                    self.universalService.showErrorMessage(error);
                    self.populateAPIEndpointsInEnv();
                    resolve(true);
                }
            )
        })
    }
   
    updateOtherConstantFilesWhichUseTheAboveURLS(){
        UPLOAD_CONS["SERVICE_URL"]["ALBUMS_SMALL_FILE_UPLOAD"] = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["boardUploadURL"] + ENV_CONFIG.commonUrls["singleFileUpload"],
        UPLOAD_CONS["SERVICE_URL"]["SMALL_FILE_UPLOAD"] = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["uploadURL"] + ENV_CONFIG.commonUrls["singleFileUpload"];
        UPLOAD_CONS["SERVICE_URL"]["CHUNK_UPLOAD_INITIATE"] = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["uploadURL"] + ENV_CONFIG.commonUrls["upload"],
        UPLOAD_CONS["SERVICE_URL"]["CHUNK_UPLOAD"] = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["uploadURL"] + ENV_CONFIG.commonUrls["chunkUpload"],
        UPLOAD_CONS["SERVICE_URL"]["CREATE_FOLDER"] = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG.commonUrls["createFolder"],
        UPLOAD_CONS["SERVICE_URL"]["CREATE_PRIVATE_FOLDER"] = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG.commonUrls["createPrivateFolder"]
    }

    async callMandatoryAPIsOnPageLoad(){
        if(localStorage.jio){
            this.universalService.fullScreenBannerDetails = await this.loginImpl.getFullScreenBannerDetails();
        }
    }


    populateAPIEndpointsInEnv(){
        let dcGroupCode = this.localStorageSvc.getDCGroupCode(true);
        if(dcGroupCode){
          ENV_CONSTANTS["privateUrls"][GlobalClassInstance.ENV_NAME] = {...ENV_CONSTANTS["privateUrls"][GlobalClassInstance.ENV_NAME] , ...ENV_CONSTANTS["multiDCUrls"][GlobalClassInstance.ENV_NAME][dcGroupCode]}
        }else{
          dcGroupCode = ENV_CONFIG["constants"]["defaultDCGroupCode"];
          ENV_CONSTANTS["privateUrls"][GlobalClassInstance.ENV_NAME] = {...ENV_CONSTANTS["privateUrls"][GlobalClassInstance.ENV_NAME] , ...ENV_CONSTANTS["multiDCUrls"][GlobalClassInstance.ENV_NAME][dcGroupCode]}
        }
        if(!APP_SETTINGS["SETTINGS"]["dcUrls"] || APP_SETTINGS["SETTINGS"]["dcUrls"].length == 0) {
            // This snippet is for populating the dcURLs of all the DCs, to handle the scenario, 
            // 1. if settings API taking time, then we need the appropriate URL for performing CROSS DC operations, eg: document edit using the objectDC property from the object metadata.
            APP_SETTINGS["SETTINGS"]["dcUrls"] = [];
            Object.keys(ENV_CONSTANTS["multiDCUrls"][GlobalClassInstance.ENV_NAME]).map(dc=>{
                APP_SETTINGS["SETTINGS"]["dcUrls"].push(ENV_CONSTANTS["multiDCUrls"][GlobalClassInstance.ENV_NAME][dc]);
            })
        }
        this.updateOtherConstantFilesWhichUseTheAboveURLS();
    }

    populateTheMultiDCURLsInENV(appSettings){
        appSettings.dcUrls.map(obj=>{
            let dcCode = obj["dcGroupCode"];
            ENV_CONSTANTS["multiDCUrls"][GlobalClassInstance.ENV_NAME][dcCode] = obj;
        })
        APP_SETTINGS["SETTINGS"] = appSettings;

        console.log("ENV URLS of MULTIDC",ENV_CONSTANTS["multiDCUrls"])
        this.populateAPIEndpointsInEnv();
    }
}

